export default {
  graphics: {
    POINT_SIZE: 10,

    BACKGROUND_COLOR: { r: 0x10, g: 0x10, b: 0x10 },
    CRYSTAL_COLOR: { r: 0x3e, g: 0x82, b: 0xf7 }
  },

  animation: {
    STEP_TIME_MS: 10,
    FF_STEP_TIME_MS: 0.05,
    HALT_THRESHOLD_MS: 500
  }
};



// WEBPACK FOOTER //
// ./src/constants.js